<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
    fluid
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BRow
      class="py-2"
    >
      <BCol
        cols="12"
        md="6"
      >
        <BFormGroup
          label="Technical Officer"
          label-for="filterOfficer"
          label-class="font-weight-bolder"
          class="mb-2"
        >
          <VSelect
            v-model="tablePlans.selected.fsOfficer"
            placeholder="filter officer here"
            input-id="filterOfficer"
            label="officer_name"
            clearable
            append-to-body
            :options="(tablePlans.options.fsOfficers)"
            :loading="(tablePlans.fetching.fsOfficers)"
            :disabled="(tablePlans.busy || tablePlans.fetching.fsOfficers)"
            :calculate-position="calculateDropPosition"
            @search="searchFilterFSOfficers"
          >
            <template #option="{ officer_name, mobile_number, photo_url }">
              <div class="d-flex flex-column flex-md-row py-1">
                <div class="flex-grow-1 d-flex align-items-center">
                  <div class="mr-2">
                    <BAvatar
                      v-if="photo_url"
                      :src="getOfficerProfile(photo_url)"
                      variant="primary"
                      size="28px"
                    />
                    <BAvatar
                      v-else
                      :text="String(officer_name).charAt(0)"
                      variant="primary"
                      size="28px"
                    />
                  </div>
                  <div class="d-flex flex-column">
                    <div
                      class="text-break text-wrap"
                      v-text="officer_name"
                    />
                    <strong>{{ mobile_number || '' }}</strong>
                  </div>
                </div>
              </div>
            </template>
            <template #selected-option="{ officer_name, photo_url }">
              <div class="d-flex flex-column flex-md-row">
                <div class="flex-grow-1 d-flex align-items-center">
                  <div class="mr-2">
                    <BAvatar
                      v-if="photo_url"
                      :src="getOfficerProfile(photo_url)"
                      variant="primary"
                      size="28px"
                    />
                    <BAvatar
                      v-else
                      :text="String(officer_name).charAt(0)"
                      variant="primary"
                      size="28px"
                    />
                  </div>
                  <div
                    class="text-break text-wrap"
                    v-text="officer_name"
                  />
                </div>
              </div>
            </template>
            <template #no-options="">
              no available officer
            </template>
          </VSelect>
        </BFormGroup>
      </BCol>
    </BRow>

    <BRow>
      <BCol
        cols="12"
      >
        <BOverlay
          class="w-100 py-2"
          rounded
          opacity="0.1"
          spinner-variant="primary"
          :show="tablePlans.busy"
        >
          <full-calendar
            ref="fullCalendar"
            class="w-100 py-1 rounded-lg"
            :options="calendarOptions"
          >
            <template #eventContent="{ event, view }">
              <div
                v-if="event.extendedProps"
                class="d-flex flex-column rounded-lg position-relative"
              >
                <template v-if="view.type === 'listMonth'">
                  <ListMonthView
                    :event="event"
                    @view="viewPlan"
                  />
                </template>
                <template
                  v-else
                >
                  <GridMonthView
                    :event="event"
                    @view="viewPlan"
                  />
                </template>
              </div>
            </template>
          </full-calendar>

        </BOverlay>
      </BCol>
    </BRow>

    <BModal
      ref="modalViewPlan"
      size="lg"
      title="Plan"
      scrollable
      centered
      hide-header
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      content-class="scrollable-tabs"
      modal-class="full-height modal-no-padding"
      aria-hidden="false"
      role="dialog"
    >
      <BTabs
        active-nav-item-class="font-weight-bold text-uppercase text-primary"
        content-class="scrollable"
      >
        <BTab class="p-2">
          <template #title>
            <div class="text-md-nowrap">
              <i
                :class="['fa-xl fad fa-file-lines']"
              />
              <b
                :class="['is-tab-active ml-1']"
              >
                Details
              </b>
            </div>
          </template>

          <BRow>
            <BCol
              cols="12"
              md="3"
            >
              <BFormGroup
                label="Event Date"
                label-for="fDate"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormInput
                  id="fDate"
                  v-model="formPlan.event_date"
                  disabled
                />
              </BFormGroup>
            </BCol>

            <BCol cols="12" />

            <BCol
              cols="12"
              md="6"
            >
              <BFormGroup
                label="Activity"
                label-for="fActivity"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormInput
                  id="fActivity"
                  v-model="formPlan.activity_name"
                  disabled
                />
              </BFormGroup>
            </BCol>

            <BCol
              cols="12"
              md="3"
            >
              <BFormGroup
                label="Initial Number of Activities"
                label-for="fNumberOfActivities"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormInput
                  id="fNumberOfActivities"
                  v-model="formPlan.number_of_activities"
                  disabled
                />
              </BFormGroup>
            </BCol>

            <BCol
              cols="12"
              md="3"
            >
              <BFormGroup
                label="New Number of Activities"
                label-for="fNewNumberOfActivities"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormInput
                  id="fNewNumberOfActivities"
                  v-model="formPlan.new_number_of_activities"
                  disabled
                />
              </BFormGroup>
            </BCol>

            <BCol
              cols="12"
              md="6"
            >
              <BFormGroup
                label="Province"
                label-for="fProvince"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormInput
                  id="fProvince"
                  v-model="formPlan.province_name"
                  disabled
                />
              </BFormGroup>
            </BCol>

            <BCol
              cols="12"
              md="6"
            >
              <BFormGroup
                label="Municipality"
                label-for="fMunicipality"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormInput
                  id="fMunicipality"
                  v-model="formPlan.municipality_name"
                  disabled
                />
              </BFormGroup>
            </BCol>

            <BCol
              cols="12"
            >
              <BFormGroup
                label="Remarks"
                label-for="fRemarks"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormTextarea
                  id="fRemarks"
                  v-model="formPlan.remarks"
                  placeholder="no remarks"
                  rows="4"
                  max-rows="6"
                  disabled
                />
              </BFormGroup>
            </BCol>

            <BCol
              cols="12"
              md="6"
            >
              <BFormGroup
                label="Created By"
                label-for="fCreatedBy"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormInput
                  id="fCreatedBy"
                  v-model="formPlan.created_by_name"
                  disabled
                />
              </BFormGroup>
            </BCol>
          </BRow>
        </BTab>
      </BTabs>
      <template #modal-footer="{ cancel, visible }">
        <div class="w-100 d-flex justify-content-end align-items-center gap-2">
          <BButton
            v-if="visible"
            variant="outline-dark"
            :disabled="state.busy"
            @click.prevent="cancel()"
          >
            Close Window
          </BButton>
        </div>
      </template>
    </BModal>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'
import MOMENT from 'moment'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { isEmpty } from 'lodash'

import ListMonthView from '@/views/asm/officers/monthly-plans/ListMonthView.vue'
import GridMonthView from '@/views/asm/officers/monthly-plans/GridMonthView.vue'

import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'
import IMAGE_URL from '@/mixins/image-url'
import MFSOfficers from '@/mixins/accounts/fsos'
import MActivities from '@/mixins/maintenances/activities'
import MCustomers from '@/mixins/accounts/customers'
import MCrops from '@/mixins/maintenances/crops'
import MProvinces from '@/mixins/locations/provinces'
import MMunicipalities from '@/mixins/locations/municipalities'
import MBarangays from '@/mixins/locations/barangays'

import { SASMFsoMonthlyPlan } from '@/services/asm'

// VSELECT MIXINS

// FULLCALENDAR PLUGINS

// import Attachment from './Attachment.vue'

export default {

  name: 'ASMOfficerMonthlyPlans',

  components: {
    // Attachment,
    ListMonthView,
    GridMonthView
  },

  mixins: [
    MFSOfficers,
    MProvinces,
    MMunicipalities,
    MBarangays,
    MActivities,
    MCustomers,
    MCrops,
    MISC,
    FORMATTER,
    IMAGE_URL
  ],

  middleware: ['auth', 'asm'],

  metaInfo: () => ({
    title: 'Plans'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false,
        editable: true
      },
      selected: {
        activityType: 'Event'
      },
      activityRules: {
        customer_per_event: 0,
        customer: 0,
        barangay: 0,
        actual_hectares: 0,
        customer_attended: 0,
        actual_costs: 0,
        customer_bought: 0,
        actual_sales: 0,
        customer_bookings: 0,
        booking_sales: 0
      },
      formPlan: {
        id: '',
        event_date: '',
        schedule: '',
        activity_name: '',
        number_of_activities: '',
        new_number_of_activities: '',
        province_name: '',
        municipality_name: '',
        remarks: '',
        created_by_name: '',
        active: 1
      },
      tablePlans: {
        busy: false,
        fetching: {
          fsOfficers: false
        },
        options: {
          fsOfficers: []
        },
        selected: {
          team: {
            id: ''
          },
          area: {
            id: ''
          },
          fsOfficer: ''
        },
        filter: {
          status: 'All',
          officer: ''
        },
        rows: []
      },
      calendarOptions: {
        timeZone: 'Asia/Taipei',
        loading: isLoading => {
          this.tablePlans.busy = isLoading
        },
        plugins: [
          dayGridPlugin,
          listPlugin,
          timeGridPlugin,
          interactionPlugin
        ],
        headerToolbar: this.isMobile() ? {
          left: 'prev,today,next dayGridMonth,listMonth',
          right: 'title'
        } : {
          left: 'title',
          center: '',
          right: 'prev,today,next dayGridMonth,dayGridWeek,listMonth'
        },
        validRange: {
          start: '',
          end: ''
        },
        initialView: this.isMobile() ? 'listMonth' : 'dayGridMonth',
        views: {
          dayGridMonth: {
            buttonText: 'Month'
          },
          dayGridWeek: {
            buttonText: 'Week'
          },
          listMonth: {
            buttonText: 'Schedule'
          }
        },
        moreLinkClick: 'listMonth', // popover, viewName
        moreLinkContent: planLists => `View ${planLists.num} plans`,
        initialEvents: [],
        dayMaxEvents: true,
        eventMaxStack: 3,
        editable: false,
        droppable: false,
        selectMirror: false,
        weekends: true,
        events: this.eventProvider,
        eventClick: this.viewPlan
      },
      calendarApi: null
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    })
  },

  watch: {
    'tablePlans.selected.fsOfficer' (officer) {
      this.tablePlans.filter.officer = officer?.id || ''

      this.refetchEvents()
    }
  },

  mounted () {
    if (this.currentUser) {
      this.tablePlans.selected.team = {
        id: this.currentUser?.team || ''
      }

      this.tablePlans.selected.area = {
        id: this.currentUser?.area || ''
      }

      this.getFSOfficers(this.tablePlans, '', this.currentUser.team, this.currentUser.area)

      this.$nextTick(() => {
        this.calendarApi = this.$refs.fullCalendar?.getApi()
      })
    }
  },

  methods: {

    async eventProvider (calendar, validData, invalidData) {
      const currentMonth = MOMENT(calendar.startStr)

      const isStartOfCalendarEndOfLastMonth = Number(currentMonth.format('D')) >= 20
      const schedule = isStartOfCalendarEndOfLastMonth ? currentMonth.add(1, 'month').format('YYYY-MM') : currentMonth.format('YYYY-MM')

      const payload = {
        schedule,
        creator_id: this.tablePlans.filter.officer,
        area_id: this.currentUser?.area || ''
      }

      return await SASMFsoMonthlyPlan.get(payload).then(
        ({ data }) => {
          const events = data.filter(
            item => isEmpty(item.deleted_at) || (!isEmpty(item.deleted_at) && MOMENT(item.event_date).isBefore(MOMENT(item.deleted_at)))
          ).map(
            item => {
              const eventDate = this.dateFormatter(item.event_date)

              return ({
                id: item.id,
                title: item?.activity?.activity_name || '',
                start: this.dateTimeLocalFormatter(`${eventDate} 08:00:00`),
                end: this.dateTimeLocalFormatter(`${eventDate} 17:00:00`),
                extendedProps: item,
                allDay: true,
                editable: false,
                droppable: false
              })
            }
          )

          this.tablePlans.rows = events

          validData(events)
        }
      ).catch(() => {
        invalidData([])
      })
    },

    refetchEvents () {
      this.$refs.fullCalendar.calendar.refetchEvents()
    },

    searchFilterFSOfficers (search, loading) {
      this.searchFSOfficersProvider(this.tablePlans, search, loading)
    },

    viewPlan ({ event: { extendedProps: plan }, view }) {
      if (view.type === 'listMonth') {
        return
      }

      this.formPlan = Object.assign(this.formPlan, {
        id: plan?.id,
        event_date: this.dateFormatter(plan.event_date),
        schedule: plan.schedule,
        activity_name: plan.activity?.activity_name || '',
        number_of_activities: plan.number_of_activities,
        new_number_of_activities: plan.new_number_of_activities,
        province_name: plan.province?.province_name || '',
        municipality_name: plan.municipality?.municipality_name || '',
        remarks: plan.remarks,
        created_by_name: this.getFullName('', '', plan.user),
        active: plan.active
      })

      this.$refs.modalViewPlan.show()
    }

  }
}
</script>
